<div class="wrapper">
  <a *ngIf="vorige" (click)="navigaarNaarVorige()"><i class="icon-arrow-l"></i></a>
  <span>{{label}}</span>
  <a *ngIf="volgende" (click)="navigaarNaarVolgende()"><i class="icon-arrow"></i></a>
</div>

